// Germany
export const locale = {
  lang: 'de',
  data: {
    TRANSLATOR: {
      SELECT: 'Wähle deine Sprache',
    },
    MENU: {
      NEW: 'Neu',
      ACTIONS: 'Aktionen',
      CREATE_POST: 'Beitrag erstellen',
      PAGES: 'Seiten',
      FEATURES: 'Eigenschaften',
      APPS: 'Apps',
      DASHBOARD: 'Instrumententafel',
      CALENDAR: 'Kalender',
      ROOMS: 'Räume',
      REPORT: 'Störungen melden',
      USERSETTINGS: 'Benutzereinstellungen',
      SYSTEMSETTINGS: 'Systemeinstellungen',
      LOGOCONFIGURATION: 'Logo-Konfiguration',
      EMAILCONFIGURATION: 'E-Mail-Konfiguration',
      EQUIPMENTS: 'Ausrüstungen',
      STYLESETTINGS: ' Stileinstellungen',
      CONFIGURATIONBYLOCATION: 'Konfiguration nach Standort',
      ROOMSETTINGS: 'Raumeinstellungen',
      ACCOUNTINFORMATION: 'Kontoinformationen',
      BOOKING: 'Buchung',
      CHECKOUTS: 'Kassen',
      VISITORS: 'Besucher',
      VISITS: 'Besuche',
      CONFIGURECUSTOMERADMIN: 'Konfigurieren Sie den Kundenadministrator',
      MRROOM: 'Herr Zimmer',
      ADMMINBACKOFFICE: 'Admin Back Office',
      ADMIN: 'Administrator',
      MRVISITS: 'Herr Besuche',
    },
    ROOMS: {
      LOCATION: 'Ort',
      ROOMS: 'Räume',
      EQUIPMENTS: 'Ausrüstungen',
      STARTDATE: 'Anfangsdatum',
      ENDDATE: 'Endtermin',
      STARTTIME: 'Startzeit',
      ENDTIME: 'Endzeit',
      TIMEDURATION: 'Zeitdauer',
      ALL: 'Alle',
      MEETINGROOM: 'Konferenzraum',
      DESK: 'Schreibtisch',
      PARKINGSEATS: 'Parkplätze',
      SERVICE: 'Bedienung',
      PLANT: 'Pflanze',
      BOOK: 'Buch',
      SERVICES: 'Dienstleistungen',
      CATERING: 'Gastronomie',
      ITSUPPORT: 'IT-Unterstützung',
      MOBILEEQUIPMENT: 'Mobilgeräte',
      SPECIAL: 'Besondere',
      COMMINGSOON: 'Kommt bald',
      MAPPLANT: 'Kartenanlage',
      ROOMBOOKING: 'Zimmerbuchung',
      LOCATIONS: 'Ort',
      RESOURCES: 'Ressourcen',
      REQUESTERNAME: 'Name des Anfragenden',
      SUBJECT: 'Gegenstand',
      DESCRIPTION: 'Beschreibung',
      ADDUSER: 'Nutzer hinzufügen',
      ADDVISITORS: 'Besucher hinzufügen',
      CATERINGDESCRIPTION: 'Catering Beschreibung',
      MOBILEEQUIPMENTDESCRIPTION: 'Beschreibung der mobilen Ausrüstung',
      ITSUPPORTDESCRIPTION: 'Beschreibung des IT-Supports',
      SPECIALSERVICE: 'Spezialdienst',
      SPECIALSERVICEDESCRIPTION: 'Spezielle Servicebeschreibung',
      REQUESTEREMAIL: 'Anforderer-E-Mail',
    },
    ROOMBOOKING: {
      NEWBOOKING: 'Neue Buchung',
      LOCATIONS: 'Standorte',
      BUILDING: 'Building',
      FLOOR: 'Floor',
      RESOURCES: 'Ressourcen',
      STARTDATE: 'Anfangsdatum',
      ENDDATE: 'Endtermin',
      STARTTIME: 'Startzeit',
      ENDTIME: 'Endzeit',
      TIMEDURATION: 'Zeitdauer',
      DESKS: 'Schreibtische',
      REQUESTORNAME: 'Name des Antragstellers',
      REQUESTOREMAIL: 'E-Mail des Antragstellers',
      SUBJECT: 'Gegenstand',
      ADDUSERS: 'Benutzer hinzufügen',
      ADDVISITORS: 'Besucher hinzufügen',
      PARKINGSEATS: 'Parkplätze',
      CATERRING: 'Gastronomie',
      MOBILEEQUIPMENT: 'Mobile Geräte',
      ITSUPPORT: 'IT-Unterstützung',
      CATERINGDESCRIPTION: 'Catering Beschreibung',
      MOBILEEQUIPMENTDESCRIPTION: 'Beschreibung der mobilen Ausrüstung',
      ITSUPPORTDESCRIPTION: 'Beschreibung des IT-Supports',
      SPECIALSERVICE: 'Spezialdienst',
      SPECIALSERVICEDESCRIPTION: 'Spezielle Servicebeschreibung',
      BOOK: 'Buch',
      CANCEL: 'Stornieren',
      BACK: 'Zurück',
      EQUIPMENT: 'Ausrüstung',
      STARTDATEISREQUIRED: 'Startdatum ist erforderlich',
      ENDDATEISREQUIRED: 'Enddatum ist erforderlich',
      STARTTIMEISREQUIRED: 'Startzeit ist erforderlich',
      ENDTIMEISREQUIRED: 'Endzeit ist erforderlich',
      ROOMS: 'Räume',
      DESCRIPTION: 'Beschreibung',
      CLEANING: 'Reinigung',
      CLEANINGDESCRIPTION: 'Cleaning Beschreibung',
      CHECKROOMAVAILABLITY: 'Überprüfen Sie die Verfügbarkeit des Zimmers',
      EDITBOOKING:'Edit Booking',

      CAPACITY:'Capacity', 
      COMPANY:'Company', 
      VISITORNAME:'Visitor Name',
      DRIVER: 'Driver',
      LICENSEPLATE: 'License Plate',
      USAGETYPE: 'Usage Type',
      SELECTBUILDING: 'Select Your Building',
      SELECTFLOOR: 'Select Your Floor'
    },
    DASHBOARD: {
      FROM: 'von',
      TO: 'Zu',
      NOWINUSE: 'Jetzt in Gebrauch',
      FREEROOMS: 'Freie Zimmer',
      FREEDESKS: 'Kostenlose Schreibtische',
      FREEPARKINGSEATS: 'Kostenloser Parkplatz',
      TODAY: 'Heute',
      RESERVATIONSOFROOMS: 'Reservierung von Zimmern',
      RESERVATIONSOFDESKS: 'Reservierungen von Schreibtischen',
      RESERVATIONSOFPARKINGSEATS: 'Reservierung von Parkplätzen',
      USERSMISSEDCHECKIN: 'Benutzer haben den Check-In verpasst',
      NORECENTCHECKIN: 'Kein aktueller Check-In',
      CURRENTMONTH: 'Aktueller Monat',
      RESERVATIONSPERROOM: 'Reservierungen pro Zimmer',
      RESERVATIONSPERDESK: 'Reservierungen pro Schreibtisch',
      PARKINGSEATSRESERVATIONS: 'Reservierung von Parkplätzen',
      RESERVATIONSPERUSER: 'Reservierungen pro Benutzer',
      MISSINGRESERVATIONS: 'Fehlende Reservierungen',
      TIMEOFRESERVATIONSPERUSER: 'Reservierungszeit pro Benutzer',
      TIMEOFRESERVATIONSPERROOM: 'Zeitpunkt der Reservierung pro Zimmer',
      TIMEOFRESERVATIONSPERDESK: 'Reservierungszeit pro Schreibtisch',
      TOTALCOSTPERUSER: 'Gesamtkosten pro Benutzer',
      DOWNLOADASCSVFILE: 'Als CSV-Datei herunterladen',
    },
    USERSETTINGS: {
      UPLOADCSV: 'Laden Sie CSV hoch',
      IMPORTFROMLDAP: 'Aus LDAP importieren',
      AZUREACTIVEDIRECTORY: 'Azure Active Directory',
      SSO: 'SSO',
      ADD: 'Hinzufügen',
      NAME: 'Name',
      EMAIL: 'Email',
      LOCATION: 'Ort',
      ROLE: 'Rolle',
      ACTION: 'Aktion',
      FILTER: 'Filter',
      CSVFILE: 'CSV-Datei',
      DOWNLOADTEMPLATE: 'Vorlage herunterladen',
      UPLOAD: 'Hochladen',

      LDAPSERVER: 'LDAP-Server',
      PORT: 'Hafen',
      DISABLETLS: 'Deaktivieren Sie TLS',
      IMPORT: 'Importieren',
      CANCEL: 'Stornieren',
      USERNAME: 'Nutzername',
      PASSWORD: 'Passwort',
      CHECKCONNECTION: 'Überprüfen Sie Ihre Verbindung',
      LDAPSERVERBASE: 'LDAP-Serverbasis',
      LDAPSEARCHFILTER: 'LDAP-Suchfilter',
      DEFAULTADUSERMAILBOX: 'Standard-AD-Benutzerpostfachfilter',
      CUSTOMLDAPFILTER: 'Benutzerdefinierter LDAP-Filter',
      LDAPRFIDATTRIBUTE: 'LDAP-RFID-Attribut (optional)',
      COUNTRY: 'Land',
      ADDUSER: 'Nutzer hinzufügen',
      ADDROLES: 'Rollen hinzufügen',
      ROLENAME: 'Rollenname',
      ACCESSRIGHTS: 'Zugangsrechte',

    },
    USERACCESSRIGHTS: {
      BOOKABUILDING: 'Buchen Sie ein Gebäude',
      BOOKADESK: 'Buchen Sie einen Schreibtisch',
      ORDERCATERING: 'Catering bestellen',
      ENDABOOKING: 'Beenden Sie eine Buchung',
      ACTIVATEINACTIVATE: 'Besprechungsräume aktivieren / deaktivieren',
      PARKINGCHECKOUT: 'Park-Check-Out',
      ACTIVATEINACTIVATEDISPLAYS: 'Anzeigen aktivieren / deaktivieren',
      BOOKAFLOOR: 'Buchen Sie eine Etage',
      BOOKAPARKINGSEATS: 'Buchen Sie einen Parkplatz',
      ORDERMOBILEEQUIPMENT: 'Bestellen Sie mobile Geräte',
      DELETEABOOKING: 'Buchung löschen',
      ACTIVATEINACTIVATEDESK: 'Schreibtische aktivieren / deaktivieren',
      ACTIVATEINATIVATEKIOSKS: 'Kioske aktivieren / inaktivieren',
      ORDERSPECIALSERVICES: 'Bestellen Sie spezielle Dienstleistungen',
      BOOKAROOM: 'Ein Zimmer buchen',
      ORDERITSERVICES: 'Bestellen Sie IT-Services',
      EDITABOOKING: 'Buchen Sie eine Buchung',
      EXTENDABOOKING: 'Buchung verlängern',
      ACTIVATEINACTIVATEPARKINGSEATS: 'Parkplätze aktivieren / inaktivieren',
      ACTICATEINACTICATEVIEWPOINTS: 'ViewPoints aktivieren / deaktivieren',

    },
    LOGOCONFIGURATION: {
      ENABLELOGOCHANGES: 'Logoänderungen aktivieren',
      UPLOADLOGO: 'Logo hochladen',
      URL: 'URL',
      OR: '(oder)',
      SAVE: ' speichern',
    },
    EMAILCONFIGURATION: {
      EMAILCONFIGURATION: 'E-Mail-Konfiguration',
      EMAIL: 'Email',
      PASSWORD: 'Passwort',
      HOSTSERVER: 'Host-Server',
      PORT: 'Hafen',
      CHECKEMAIL: 'E-Mail überprüfen',
      SAVE: 'speichern',
      TOEMAIL: 'Eine E-Mail schicken',
    },
    STYLESETTINGS: {
      SYSTEMSTYLE: 'Systemstil',
      SIDEBUTTONCOLOR: 'Farbe der Seitentaste',
      ACTIONBUTTONCOLOR: 'Farbe der Aktionsschaltfläche',
      TOPTITLES: 'Top-Titel',
      TEXTCOLOR: 'Textfarbe',
      BACKGROUNDCOLOR: 'Hintergrundfarbe',
      KIOSKCHECKINSTYLE: 'Kiosk-Check-In-Stil',
      BACKGROUNDIMAGE: 'Hintergrundbild',
      KIOSKINFORMATION: 'Kiosk-Informationen',
      SERVICESVIEWPOINTSDISPLAYINFORMATION: 'Service Viewpoints Informationen anzeigen',
      SAVE: 'speichern',
      CANCEL: 'Stornieren',
      RESTORETODEFAULT: 'Zurück zu Werkeinstellungen',
    },
    CONFIGURATIONBYLOCATION: {
      SEARCHHERE: 'Suche hier',
      COUNTRY: 'Land',
      LOCATION: 'Ort',
      TIMEZONE: 'Zeitzone',
      ACTIONS: 'Aktionen',
    },
    EQUIPMENTS: {
      EQUIPMENTALIGNMENT: 'Geräteausrichtung',
      SEARCHHERE: 'Suche hier',
      ICON: 'Symbol',
      TITLE: 'Titel',
      ACTION: 'Aktion',
      LEFT: 'Links',
      RIGHT: 'Recht',
      TOP: 'oben',
      BOTTOM: 'Unterseite',
      ADD: 'Hinzufügen',
    },
    ACCOUTINFORMATION: {
      COMPANYNAME: 'Name der Firma',
      CONTACTNAME: 'Kontaktname',
      PHONENUMBER: 'Telefonnummer',
      COUNTRY: 'Land',
      RESELLER: 'Wiederverkäufer',
      EMAILTOREGISTRATION: 'E-Mail an die Registrierung',
      TYPEOFACCOUNT: 'Art von Account:',
      NUMBEROFROOMS: 'Anzahl der Räume',
      NUMBEROFROOMSDISPLAYS: 'Anzahl der Zimmeranzeigen',
      NUMBEROFDESKS: 'Anzahl der Schreibtische',
      NUMBEROFDESKSDISPLAYS: 'Anzahl der Schreibtischanzeigen',
      NUMBEROFPARKINGSPACES: 'Anzahl der Parkplätze',
      NUMBEROFSERVICESVIEWPOINTS: 'Anzahl der Services ViewPoints',
      NUMBEROFKIOSKS: 'Anzahl der Kioske',
      ACCOUNTID: 'Konto-ID',
      VALIDFROM: 'Gültig ab',
      VALIDTO: 'Gültig bis',
      CONTACTSUPPORT: 'Kontaktieren Sie Support',
      MESSAGE: 'Botschaft',
      CLOSE: 'Schließen',
      SEND: 'Senden',
    },
    LOGINGPAGE: {
      WELCOMETOMRROOMS: 'Willkommen bei MrRooms',
      NEWHERE: 'Neu hier?',
      DEMOACCOUNT: 'Demo-Konto',
      ENTERYOURDETAILSTOCREATEYOURACCOUNT: 'Geben Sie Ihre Daten ein, um Ihr Konto zu erstellen',
      COMPANYNAME: 'Name der Firma',
      CONTACTNAME: 'Kontaktname',
      PHONE: 'Telefon',
      COUNTRY: 'Land',
      CONFIRMPASSWORD: 'Kennwort bestätigen',
      ACCEPTTERMSCONDITIONS: 'Akzeptieren Sie die Allgemeinen Geschäftsbedingungen',
      TERMSANDCONDITIONS: 'Geschäftsbedingungen',
      EMAIL: 'Email',
      PASSWORD: 'Passwort',
      FORGOTPASSWORD: 'Passwort vergessen',
      DISCOVERAMAZINGWORKSPACE: 'Entdecken Sie Amazing Workspace',
      SERVICEVIEWPOINTS: 'Service-Gesichtspunkte',
      KIOSKSMAPPLANTS: 'Kioske Karte Pflanzen',
      ENTERYOUREMAILTORESETYOURPASSWORD: 'Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen',
      SUBMIT: 'einreichen',
      CANCEL: 'Stornieren',
      SIGNIN: 'Einloggen',
      EMAILIDISREQUIRED: 'E-Mail-ID ist erforderlich',
      PASSWORDISREQUIRED: 'Passwort wird benötigt',
      THELOGINDETAILSAREINCORRECT: 'Die Anmeldedaten sind falsch',
      COMPANYNAMEISREQUIRED: 'Firmenname ist erforderlich',
      NAMEISREQUIRED: 'Name ist erforderlich',
      PHONENUMBERISREQUIRED: 'Telefonnummer ist erforderlich',
      COUNTRYISREQUIRED: 'Land ist erforderlich',
      EMAILISREQUIRED: 'E-Mail ist erforderlich',
      CONFIRMPASSWORDISREQUIRED: 'Bestätigen Sie, dass das Passwort erforderlich ist',
      ACCEPTTSCSISREQUIRED: 'Akzeptieren Sie die AGB',

    },
    CALENDAR: {

      TODAY: 'Heute',
      MEETINGROOMS: 'Besprechungszimmer',
      DESK: 'Schreibtisch',
      PARKINGSEATS: 'Parkplätze',
      MONTH: 'Monat',
      WEEK: 'Woche',
      DAY: 'Tag',
      SUNDAY: 'Sonntag',
      MONDAY: 'Montag',
      TUESDAY: 'Dienstag',
      WEDNESDAY: 'Mittwoch',
      THURSDAY: 'Donnerstag',
      FRIDAY: 'Freitag',
      SATURDAY: 'Samstag',
    },
  }
};
